export default __webpack_public_path__ + "static/guara-a77854ede8da972a0b1f836133289a0e.jpg";